import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

import { ReactComponent } from './office-desk.svg';

export const OfficeDeskIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon ref={ref} component={ReactComponent} inheritViewBox {...props} />
  ),
);

if (process.env.NODE_ENV !== 'production') {
  OfficeDeskIcon.displayName = 'OfficeDeskIcon';
}
